import axios from 'axios'

const state = {
  lists: [],
  filter: {},
  sort: {},
  total: 0,
  page: 1,
  perPage: 10,
  loaded: false,
}

const getters = {}

const mutations = {
  SET_STATE_LOADED(state, flag) {
    state.loaded = flag
  },
  SET_LISTS_TOTAL(state, total) {
    state.total = total
  },
  SET_LISTS(state, data) {
    state.lists = data
  },
  SET_PAGE(state, { page, perPage }) {
    state.page = page
    state.perPage = perPage
  },
  SET_FILTER_PARAMS(state, params) {
    state.filter = { ...params }
  },
  SET_SORT_PARAMS(state, params) {
    state.sort = { ...params }
  },
  NEW_ITEM(state, item) {
    state.lists.concat(item)
    state.total = state.total++
  },
  UPDATE_ITEM(state, newItem) {
    state.lists.forEach((element, index) => {
      if (element.id === newItem.id) {
        state.lists[index] = newItem
      }
    })
  },
}

const actions = {
  fetchLists,
  setPage,
  setFilterParams,
  setSortParams,
  deleteItem,
  newItem,
  updateItem,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

function setPage({ commit, state, rootState }, { page, perPage }) {
  commit('SET_PAGE', { page, perPage })
  return fetchLists({ commit, state, rootState })
}

function setFilterParams({ commit, state, rootState }, params) {
  commit('SET_FILTER_PARAMS', params)
  return fetchLists({ commit, state, rootState })
}

function setSortParams({ commit, state, rootState }, params) {
  commit('SET_SORT_PARAMS', params)
  return fetchLists({ commit, state, rootState })
}

function fetchLists({ commit, state, rootState }) {
  // Refresh the lists
  commit('SET_LISTS', null)
  commit('SET_STATE_LOADED', false)
  // Fetch the lists from the API
  return axios
    .get('/api/v1/company', {
      params: {
        filter: state.filter,
        noMyHubs: true,
        page: state.page,
        per_page: state.perPage,
        sort: state.sort,
      },
    })
    .then((response) => {
      const result = response.data
      // save the lists in Vuex store
      commit('SET_LISTS', result.data)
      commit('SET_LISTS_TOTAL', result.total)
      return result
    })
    .then(() => {
      commit('SET_STATE_LOADED', true)
    })
}

function deleteItem({ commit, state, rootState }, id) {
  // Refresh the lists
  commit('SET_LISTS', null)
  // Fetch the lists from the API
  return axios.delete(`/api/v1/company/${id}`).then((response) => {
    if (response.data) {
      return fetchLists({ commit, state, rootState })
    }
  })
}

function newItem({ commit, state, rootState }, params) {
  // save the company info
  return axios.post(`/api/v1/company`, params).then((response) => {
    // add company in store
    commit('NEW_ITEM', response.data)
    return response.data
  })
}

function updateItem({ commit, state, rootState }, params) {
  // save the company info
  return axios.post(`/api/v1/company/${params.id}`, params).then((response) => {
    // save the company in store
    commit('UPDATE_ITEM', response.data)
    return response.data
  })
}
